import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  editLocationButtonVariant: 'tertiary',
  dialogOptions: { type: 'panel' }
} satisfies RecursivePartial<DialogConfig['changeStoreConfirmation']>
